import { SET_USDC_BALANCE, SET_SAN_BALANCE } from "../types";

export const setUsdcBalance = (value) => (dispatch) => {
  dispatch({
    type: SET_USDC_BALANCE,
    payload: value,
  });
};

export const setSanBalance = (value) => (dispatch) => {
  dispatch({
    type: SET_SAN_BALANCE,
    payload: value,
  });
};
